import { Component, OnInit, ViewContainerRef, Input } from '@angular/core'; 
import { OperationsService, StorageService, LoansService, DecisionService,AuthenticationService } from '../../_services/index'; 
import { ToastrService } from 'ngx-toastr'; 

@Component({
  selector: 'app-creditbureaus',
  templateUrl: './creditbureaus.component.html',
  styleUrls: ['./creditbureaus.component.css']
})
export class CreditbureausComponent implements OnInit {
  @Input('where_from') where_from = '1';
  @Input('bureau_selected') bureau_selected = '0';
  loading = false;
  firstcentral = {
    'user_id':'',
    'password':''
  }
  crc = {
    'user_id':'',
    'password':''
  }
  crservices = {
    'user_id':'',
    'password':''
  }
  currentUser:any;
  constructor(public authService:AuthenticationService,public toastr: ToastrService, vcr: ViewContainerRef, public loansService: LoansService, 
    public storageService: StorageService,
    public operationsService: OperationsService,
    public decisionService: DecisionService) {
    this.currentUser = this.storageService.read<any>('currentUser');  
  }
  showSuccess(message) {
    this.toastr.success(message, 'Success!');
  }

  showError(message) {
    this.toastr.error(message, 'Error');
  }
  ngOnInit() {
    
    
    this.operationsService.getBureauSettings(this.currentUser.token)
      .subscribe(data => {
        this.crc = data.data.crc;
        this.firstcentral = data.data.firstcentral;
        this.crservices = data.data.crservices;
        
      });
  }
  SaveFirstCentral(value, valid) {
    this.loading = true;
    this.operationsService.SaveFirstCentral(this.currentUser.token, value)
      .subscribe(data => {
        this.loading = false;
        this.showSuccess(data.message);
      });
  }

  SaveCRC(value, valid) {
    this.loading = true;
    this.operationsService.SaveCRC(this.currentUser.token, value)
      .subscribe(data => {
        this.loading = false;
        this.showSuccess(data.message);
      });
  }

  SaveCRServices(value, valid) {
    this.loading = true;
    this.operationsService.SaveCRServices(this.currentUser.token, value)
      .subscribe(data => {
        this.loading = false;
        this.showSuccess(data.message);
      });
  }
}
